import accountNumbers from '../accountNumbers';
import boosters from '../boosters';
import botChances from '../botChances';
import brands from '../brands';
import favoriteTiles from '../favoriteTiles';
import figureHunting from '../figureHunting';
import levelsPackage from '../levelsPackages';
import logs from '../logs';
import mainScreens from '../mainScreens';
import mainScreenModuleSectionTypes from '../mainScreenModuleSectionTypes';
import monthlyLimitations from '../monthlyLimitations';
import popup from '../popup/index';
import settings from '../settings';
import simulatorReactions from '../simulatorReactions';
import targetGroups from '../targetGroups';
import themes from '../themes';
import tiers from '../tiers';
import tiersDiscounts from '../tiersDiscounts';
import transactions from '../transactions/transactions';
import transactionsTypes from '../transactions/types';
// import baStatistics from '../baStatistics';

export default [
  brands,
  favoriteTiles,
  accountNumbers,
  mainScreens,
  mainScreenModuleSectionTypes,
  monthlyLimitations,
  figureHunting,
  simulatorReactions,
  boosters,
  targetGroups,
  transactionsTypes,
  transactions,
  settings,
  logs,
  levelsPackage,
  tiers,
  botChances,
  tiersDiscounts,
  themes,
  popup,
  // baStatistics,
];
